'use client'

import { createThemeOptions, ThemeProvider } from '@dxp/components/theme'
import { CssBaseline } from '@mui/material'
import {
  QueryClient as ReactQueryClient,
  QueryClientProvider as ReactQueryClientProvider,
  QueryClientProviderProps as ReactQueryClientProviderProps,
} from '@tanstack/react-query'
import { PropsWithChildren, useEffect } from 'react'

const queryClient = new ReactQueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

type QueryClientProviderProps = Omit<ReactQueryClientProviderProps, 'client'>

export const QueryClientProvider = (props: QueryClientProviderProps) => (
  <ReactQueryClientProvider {...props} client={queryClient} />
)

export function ThemeRegistry(props: PropsWithChildren) {
  return (
    <ThemeProvider
      themeOptions={createThemeOptions({
        font: {
          body: 'var(--font-body)',
          heading: 'var(--font-body)',
        },
      })}
    >
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}

export function HydrationIndicator() {
  useEffect(() => {
    document.documentElement.dataset.hydrated = 'true'
  }, [])

  return null
}
